// Vendor libraries
import { ElementRef } from '@angular/core';
import { combineLatest, debounceTime, fromEvent, map, startWith, tap } from 'rxjs';
// Services
import { ChartZoomService } from 'ChartApp/ts/features/charts-shared/services/chart-zoom.service';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/features/charts-shared/services/chart-zoom.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["panningButton"];
const _c1 = ["controls"];
const _c2 = a0 => ({ "display": a0 });
function ChartZoomControlsComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("visibility", ctx_r0.hideZoomInstructions ? "hidden" : "visible");
    i0.ɵɵproperty("textContent", "Select area\n to zoom")("hidden", ctx_r0.hideZoomInstructions)("tooltipTitle", "Click and drag to select<br>area and zoom")("tooltipHtml", true);
} }
function ChartZoomControlsComponent_div_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵlistener("click", function ChartZoomControlsComponent_div_0_ng_template_4_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.resetZoomHandler()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 10)(4, "div", 11, 2);
    i0.ɵɵlistener("click", function ChartZoomControlsComponent_div_0_ng_template_4_Template_div_click_4_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.panningHandler($event)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-reset-zoom");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c2, ctx_r0.zoomOn ? "initial" : "none"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r0.enablePanning ? "btn-primary" : "btn-secondary")("tabIndex", -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-move");
} }
function ChartZoomControlsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4, 0);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, ChartZoomControlsComponent_div_0_div_3_Template, 1, 6, "div", 5)(4, ChartZoomControlsComponent_div_0_ng_template_4_Template, 7, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const zoomBtns_r3 = i0.ɵɵreference(5);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("top", ctx_r0.top, "px")("visibility", ctx_r0.visible)("left", i0.ɵɵpipeBind1(2, 8, ctx_r0.chartLeft$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.zoomOn)("ngIfElse", zoomBtns_r3);
} }
/**
 * ChartZoomControlsComponent
 *
 * A component housing zoom related Highcharts functionality.
 * This includes the zoom-in, reset-zoom, and panning behavior.
 *
 * Inputs:
 * top: numeric top position in pixels for zoom controls position
 * hideZoomInstructions: hide the zoom control instruction box
 * mouseOverChart: A boolean describing whether the user's mouse is hovering over the chart. This is used to prevent
 *   enabling zoom when the user presses `shift` on a different part of the site ex: Typing a capital letter in a
 *   search bar.
 */
export class ChartZoomControlsComponent {
    constructor(chartZoomService) {
        this.chartZoomService = chartZoomService;
        this.top = 0;
        this.hideZoomInstructions = false;
        this.enablePanning = false;
        this.zoomOn = false;
        this.visible = 'hidden';
        this.chart$ = this.chartZoomService.getZoomEvent().pipe(tap(({ zoomedIn, panningOn }) => {
            this.zoomOn = zoomedIn;
            this.enablePanning = panningOn;
        }));
        this.chartLeft$ = combineLatest([
            fromEvent(window, 'resize').pipe(startWith({ target: window })),
            this.chartZoomService.getChartWidthChange(),
        ]).pipe(debounceTime(500), map(([_, plotChartPadding]) => {
            const zoomWidth = this.zoomControl.nativeElement.offsetWidth;
            const rightPadding = plotChartPadding + zoomWidth - 1; // 1 pixel from the chart border
            this.visible = 'visible';
            return `max(66.66%, 100% - ${rightPadding}px)`; // Zoom Controls should not go inside legend's content
        }));
    }
    resetZoomHandler() {
        this.enablePanningEventType = undefined;
        this.chartZoomService.zoomOut();
        if (this.enablePanning) {
            this.chartZoomService.updatePanning(false);
        }
    }
    /**
     * Toggle between panning and zooming on the highchart by clicking on the Move icon or holding shift.
     * Only allow users to disable panning with the same event used to enable panning.
     * @param event - A click, keydown.shift, or keyup.shift event.
     */
    panningHandler(event) {
        const panningEventType = event.type.includes('key') ? 'key' : 'click';
        if (!this.zoomOn ||
            (this.enablePanningEventType && panningEventType !== this.enablePanningEventType) ||
            (panningEventType === 'key' && !this.mouseOverChart)) {
            return;
        }
        event.preventDefault();
        const enablePanning = panningEventType === 'key' ? event.type === 'keydown' : !this.enablePanning;
        this.enablePanningEventType = enablePanning ? panningEventType : undefined;
        this.chartZoomService.updatePanning(enablePanning);
        if (!enablePanning) {
            this.panningButton.nativeElement.blur();
        }
    }
}
ChartZoomControlsComponent.ɵfac = function ChartZoomControlsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartZoomControlsComponent)(i0.ɵɵdirectiveInject(i1.ChartZoomService)); };
ChartZoomControlsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartZoomControlsComponent, selectors: [["ycn-chart-zoom-controls"]], viewQuery: function ChartZoomControlsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.panningButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.zoomControl = _t.first);
    } }, hostBindings: function ChartZoomControlsComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keydown.shift", function ChartZoomControlsComponent_keydown_shift_HostBindingHandler($event) { return ctx.panningHandler($event); }, i0.ɵɵresolveDocument)("keyup.shift", function ChartZoomControlsComponent_keyup_shift_HostBindingHandler($event) { return ctx.panningHandler($event); }, i0.ɵɵresolveDocument);
    } }, inputs: { mouseOverChart: "mouseOverChart", top: "top", hideZoomInstructions: "hideZoomInstructions" }, standalone: false, decls: 2, vars: 3, consts: [["controls", ""], ["zoomBtns", ""], ["panningButton", ""], ["class", "chart-zoom-controls", "style", "right: auto;", 3, "top", "visibility", "left", 4, "ngIf"], [1, "chart-zoom-controls", 2, "right", "auto"], ["class", "chart-zoom-controls-item text-prewrap chart-zoom-controls-info visible-lg-block", "ycnTooltip", "", "tooltipPlacement", "bottom-end", 3, "textContent", "hidden", "visibility", "tooltipTitle", "tooltipHtml", 4, "ngIf", "ngIfElse"], ["ycnTooltip", "", "tooltipPlacement", "bottom-end", 1, "chart-zoom-controls-item", "text-prewrap", "chart-zoom-controls-info", "visible-lg-block", 3, "textContent", "hidden", "tooltipTitle", "tooltipHtml"], [1, "chart-zoom-controls-item"], ["ycnTooltip", "", "tooltipTitle", "Reset", "tooltipPlacement", "bottom", 1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "chart-zoom-controls-item", "visible-lg-block", 3, "ngStyle"], ["ycnTooltip", "", "tooltipTitle", "Move (SHIFT + Click)", "tooltipPlacement", "bottom", 1, "btn", 3, "click", "ngClass", "tabIndex"]], template: function ChartZoomControlsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ChartZoomControlsComponent_div_0_Template, 6, 10, "div", 3);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        let tmp_0_0;
        i0.ɵɵproperty("ngIf", (tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.chart$)) == null ? null : tmp_0_0.enabled);
    } }, dependencies: [i2.NgClass, i2.NgIf, i2.NgStyle, i3.IconDirective, i4.TooltipDirective, i2.AsyncPipe], encapsulation: 2 });
